import { ListItemButton, Typography } from '@mui/material';
import type { SiteFileDto } from '../../api/filesApi';
import { getFileIcon } from './fileIcons';
import { formatFileSize } from './formatFileSize';

interface FileRowProps {
  file: SiteFileDto;
  onClick?: () => void;
}

export function FileRow({ file, onClick }: FileRowProps) {
  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        py: 1.5,
        px: { xs: 2, sm: 3 },
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
      data-testid={`file-row-${file.id}`}
    >
      {getFileIcon(file.contentType, 16)}
      <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }} noWrap>
        {file.name}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ flexShrink: 0, display: { xs: 'none', sm: 'block' } }}
      >
        {formatFileSize(file.fileSizeBytes)}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ flexShrink: 0, display: { xs: 'none', sm: 'block' } }}
      >
        {file.uploaderName}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ flexShrink: 0 }}
      >
        {new Date(file.uploadedAt).toLocaleDateString()}
      </Typography>
    </ListItemButton>
  );
}
